import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './styles';
import { BagWithCross } from 'icons';
import { TSizeType } from 'interfaces';

type TSoldBadgeProps = {
  size: TSizeType;
};

export const SoldBadge: FC<TSoldBadgeProps> = ({ size = 'medium' }) => {
  const { t } = useTranslation();
  return (
    <Styled.SoldBadgeWrapper $size={size}>
      {size === 'small' ? (
        <BagWithCross size={20} />
      ) : (
        <>
          <Styled.SoldBadgeImageWrapper>
            <BagWithCross size={20} />
          </Styled.SoldBadgeImageWrapper>
          <Styled.BadgeText>{t('nft.sold')}</Styled.BadgeText>
        </>
      )}
    </Styled.SoldBadgeWrapper>
  );
};
